import { formatChemicalCompoundNameAsHtml } from "@omnia/shared/utils/format"
import { param } from "../omnia"
import { INutritionService, NutrientType } from "../types"
import { LimeEnabledFromYear } from "../utils"
import { StockVm } from "./stockVm"
import { IStockNutrient } from "./types"
import { isNumber } from "@omnia/shared/utils/utils"

export function setupStocks(svc: INutritionService): StockVm[] {

    var fertStocks = svc.getFertiliserStocks().map(s => StockVm.createFromFertiliserStock(s));

    var fertProducts = svc.getFertiliserProducts()
        .filter(f => !fertStocks.find(s => s.fertiliserProductId == f.FertiliserProductId))
        .map(f => StockVm.createFromFertiliser(f));

    var stocks = [].concat(
        fertStocks,
        fertProducts
    );

    var manureStocks = svc.getManureStocks().map(s => StockVm.createFromManureStock(svc.manureAnalysis, s));
    stocks = stocks.concat(manureStocks);

    setupStockNutrients(stocks, svc.yearId >= LimeEnabledFromYear);

    stocks = stocks.sort((s1, s2) => {

        var diff = (s1.hasStock() ? 0 : 1) - (s2.hasStock() ? 0 : 1);
        if (!diff) diff = s1.description.localeCompare(s2.description);

        return diff;

    });

    return stocks;

}

export function setupStockNutrients(stocks: StockVm[], includeLime: boolean) {

    const nt = param.NutrientType().filter(p => p.value != NutrientType.Lime)

    let nutrients = nt.map(n => {
        return {
            key: n.text,
            id: n.value,
            htmlText: formatChemicalCompoundNameAsHtml(n.text),
            valueMax: Math.max.apply(Math, stocks.map(s => s.analysis).filter(f => !!f).map(f => f[n.text]).filter(v => isNumber(v)))
        }
    });

    if (includeLime) {
        nutrients.push(<IStockNutrient>{
            key: "Lime",
            id: NutrientType.Lime,
            htmlText: "NV",
            valueProvider: a => a.NeutralisingValue
        })
    }

    stocks.forEach(s => {
        s.setupNutrients(nutrients);
    });

}
